import React, { useState } from 'react'
import { Grid, Card, Popover, Typography, Checkbox } from '@mui/material'
import * as RiskEntity from '../../Entities/RiskTypes'
import { BsThreeDotsVertical } from 'react-icons/bs'
import CustomDisputeRiskTable from '../../Common/ui/riskTable'
import { useRiskStore } from '../../Containers/Risk/Store/RiskStore'
import { RiChatHistoryLine } from 'react-icons/ri'
import { LuCalendarDays } from 'react-icons/lu'
import { useTranslation } from 'react-i18next'

const RaisedComponent = ({ riskType, headerTabs, selectedMenu, handleSelect }) => {
    const { t } = useTranslation()
    const [ isModalOpen, setIsModalOpen ] = useState(false)
    const { riskInitialCount, riskAnalyzCount, riskApprovalCount, riskMonitoringCount } = useRiskStore(state => ({
        riskInitialCount: state.riskInitialCount,
        riskAnalyzCount: state.riskAnalyzCount,
        riskApprovalCount: state.riskApprovalCount,
        riskMonitoringCount: state.riskMonitoringCount
    }))
    const toggleModal = () => {
        setIsModalOpen(!isModalOpen)
    }
    const openModal = () => {
        setIsModalOpen(true)
    }

    const TableHeaders = RiskEntity?.DISPUTE_TABLE_HEADERS?.map((mapData) => {
        if (mapData?.field === RiskEntity.DOT) {
            return {
                ...mapData,
                renderCell: (params) => (
                    <div>
                        <BsThreeDotsVertical onClick={openModal} className='mt-3 '/>
                    </div>
                )
            }
        } else if (mapData?.field === 'checkbox') {
            return {
                ...mapData,
                renderCell: (params) => (
                    <Checkbox
                        checked={!!params.value}
                    />
                )
            }
        } else return mapData
    })
    const countFinder = (id) => {
        switch (id) {
        case 1:
            return riskInitialCount
        case 2:
            return riskApprovalCount
        case 3:
            return riskAnalyzCount
        case 4:
            return riskMonitoringCount
        default:
            return 0
        }
    }
    const tableBodyData = useRiskStore((state) => state.tableBodyData)

    return (
        <div className='h-[100%] flex flex-col gap-4'>
            <Grid container gap={0} direction="row" justifyContent="space-between" className='px-5 w-[100%] items-center' >
                {
                    headerTabs?.map((item, i) => {
                        return (
                            <>
                                {item.show && <Grid item xs={2.5} sm={2.5} md={2.5}>
                                    <div
                                        className={`heatmap-card ${item.selected ? 'selectedCard' : ''}`}
                                        onClick={() => handleSelect(item.id, item?.name)}
                                    >
                                        <Card className='p-5 border-2 heatmap-card-content flex' style={{
                                            border: item.selected ? '2px solid hsl(var(--primary))' : '2px solid hsl(var(--card))',
                                            background: item.selected ? 'hsl(var(--primary-foreground))' : 'hsl(var(--card))'
                                        }}>
                                            <div aria-label="" role="img" className="flex-shrink-0 flex justify-center items-center risk-avatar m-2" style={{
                                                backgroundColor: item.selected ? 'hsl(var(--primary))' : 'hsl(var(--primary-foreground))'
                                            }}>

                                                <div className='ml-2 mt-2'>{!item.selected ? item.selImg : item.defImg}</div>
                                            </div>
                                            <div className='flex flex-col justify-center pl-2'>
                                                <h3 className='font-bold text-muted'>{countFinder(item.id) || 0}</h3>
                                                <div className='text-h4 text-primary'>{item?.name}</div>
                                            </div>
                                        </Card>
                                    </div>
                                </Grid>}
                            </>

                        )
                    })
                }
            </Grid>
            <div className='mx-6 h-[100%]'>
                <CustomDisputeRiskTable riskType={riskType} tableBodyData={tableBodyData} tableHeaders={TableHeaders} selectedMenu={selectedMenu} />
            </div>
            <Popover
                open={isModalOpen}
                onClose={toggleModal}
                className='p-2'
                anchorReference="anchorPosition"
                anchorPosition={{ top: 250, left: 1320 }}>
                {/* <div className='flex'><RiVideoAddLine className='m-3'/><Typography sx={{ p: 1 }}>{t('Meeting')} </Typography></div> */}
                <div className='flex'><LuCalendarDays className='m-3'/><Typography sx={{ p: 1 }}>{t('Set Reminder')}</Typography></div>
                <div className='flex'><RiChatHistoryLine className='m-3'/><Typography sx={{ p: 1 }}>{t('Chat & Timeline')} </Typography></div>
            </Popover>
        </div>
    )
}

export default RaisedComponent
